/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../services/toast';
export default {
  name: 'blocked-user-list',
  components: {},
  props: [],
  data () {
    return {
      blockUserList:{},
      nextStep:'',
      blockUserListResults:[],
      loadmoreData: {},
      userLoading: false,
      submitted:false,
    }
  },
  computed: {
  ...mapGetters([
    'getBlockGetters'
  ]),
  getblockUserListDetailsFun(){
     this.blockUserList = this.$store.getters.getBlockGetters.data
     return
  },
  SetIntialStatus() {
    if (this.blockUserList != undefined) {
      this.nextStep = this.blockUserList.next
      this.blockUserListResults = this.blockUserList.results
    }
  },
  },
  mounted () {
    this.getblockUserListDetailsFun
    this.SetIntialStatus
    console.log(this.blockUserListResults, "user list")
  },
  methods: {
    getAgainBlockedUserList(){
      this.$store.dispatch('getBlockUserFun')
      .then((res) => {
      }).catch((err) => {
      })
    },
    unBlockedRequestSend(id){
      this.userLoading = true
      this.$store.dispatch('unBlockUserFun', {id:id} )
      .then((res) => {
        this.getAgainBlockedUserList()
        toast.success(res.data.msg);  
        this.userLoading = false
      }).catch((err) => {
        toast.error(err.data.msg);
      })
    }
  },
  watch:{
    getblockUserListDetailsFun(){
      return  this.blockUserList = this.$store.getters.getBlockGetters.data
    },
    SetIntialStatus() {
      if (this.blockUserList != undefined) {
        this.nextStep = this.blockUserList.next
        this.blockUserListResults = this.blockUserList.results
      }
    },
  }
}


